export default __webpack_public_path__ + "locales/si/Settings.json?hash=64c0abdbd671dbe7e32dbfa707bd75f7";